/** 
 * note: общие стили через `createUseStyles` для папки stations
 * */

import { createUseStyles } from 'react-jss';

export const generalStationsStyles = {
  /** например, для stations or datasource row navigation */
  pageNavigationRow: {
    width: '100%',
    display: 'flex',
    gridColumnGap: '.2rem',
    alignItems: 'center',
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  tableRow: {
    padding: '.5rem',
    // временное решение, так как при сбросе статуса могут сдвигаться строки источников в вируталке
    minHeight: '3.063rem',
    borderBottom: '1px solid rgb(237,240,242)',
    transition: 'all 0.1s linear',
    '&:hover': {
      backgroundColor: 'rgba(67, 90, 111, 0.04)',
    },
  },
  filterRow: {
    display: 'grid',
    gap: '.5rem',
    alignItems: 'center',
  },
};

export const useGeneralStationsStyles = createUseStyles({
  ...generalStationsStyles,
});
